<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Icon, ListItem } from '@Shelly/shelly-design-system';
	import { devices } from 'src/stores';
	import {
		consumption_by_device_account,
		consumption_device,
		consumption_rooms,
	} from 'src/stores/features/consumption';
	import { rooms } from 'src/stores';
	import { buildConsumptionStores } from 'src/components/EnergyMonitoring/helpers/consumption_helpers';
	import { buildEnergyInsights } from 'src/components/EnergyMonitoring/helpers/energy_insights_helpers';
	import EmWidgetShell from '../EmWidgetShell.svelte';
	import { energyMonitoringDataMode } from '../helpers/store';

	export let embedded = false;
	export let staticPreview = false;

	$: consumptionStores = buildConsumptionStores({
		rooms: $rooms,
		devices: $devices,
		consumptionRooms: $consumption_rooms,
		consumptionDevice: $consumption_device,
		consumptionByDeviceAccount: $consumption_by_device_account,
	});

	$: insights = buildEnergyInsights(
		consumptionStores,
		$devices,
		staticPreview || $energyMonitoringDataMode === 'demo',
	);
</script>

{#snippet insightsBody()}
	<div class="em-insights-body">
		<div class="em-insight-list">
			{#each insights as item (item.labelKey)}
				<ListItem
					title={$format(item.labelKey, { default: item.labelDefault })}
					subtitle={` · ${$format(item.detailKey, { default: item.detailDefault })}`}
					viewType="bar"
					progress={{
						percent: item.progress,
						title: item.value,
						color: item.type,
						showPercentBar: item.progress > 0,
					}}
					a11yProps={{
						progressbarAriaLabel: $format('energy_monitoring_insight_progress', {
							default: '{name}: {value}',
							values: {
								name: $format(item.labelKey, { default: item.labelDefault }),
								value: item.value,
							},
						}),
						progressCircleAriaLabel: '',
					}}
				/>
			{/each}
		</div>
	</div>
{/snippet}

{#if embedded}
	{@render insightsBody()}
{:else}
	<EmWidgetShell
		widgetClass="energy-widget-insights"
		title={$format('settings_title_insights', { default: 'Insights' })}
		infoText={$format('energy_monitoring_insights_info', {
			default:
				'Live signals about solar coverage, grid reliance, and standby waste based on current meter data.',
		})}
	>
		<svelte:fragment slot="actions">
			<Icon icon="fa-light fa-chart-line-up" size="s" />
		</svelte:fragment>
		{@render insightsBody()}
	</EmWidgetShell>
{/if}

<style lang="scss">
	.em-insights-body {
		display: flex;
		flex-direction: column;
		flex: 1;
		min-height: 0;
		min-width: 0;
	}

	.em-insight-list {
		display: grid;
		align-content: start;
		gap: var(--spacing-s);
		flex: 1;
		min-height: 0;
	}

	/* ListItem intentionally defaults to one line; insight explanations must wrap in narrow cards. */
	.em-insight-list :global(.text-nowrap) {
		white-space: normal;
	}
</style>
